var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98081 11.25C3.60194 11.25 3.28125 11.1188 3.01875 10.8563C2.75625 10.5938 2.625 10.2731 2.625 9.89419V1.35581C2.625 0.976937 2.75625 0.65625 3.01875 0.39375C3.28125 0.13125 3.60194 0 3.98081 0H10.2692C10.6481 0 10.9688 0.13125 11.2313 0.39375C11.4938 0.65625 11.625 0.976937 11.625 1.35581V9.89419C11.625 10.2731 11.4938 10.5938 11.2313 10.8563C10.9688 11.1188 10.6481 11.25 10.2692 11.25H3.98081ZM3.98081 10.125H10.2692C10.3269 10.125 10.3798 10.1009 10.4278 10.0528C10.4759 10.0048 10.5 9.95194 10.5 9.89419V1.35581C10.5 1.29806 10.4759 1.24519 10.4278 1.19719C10.3798 1.14906 10.3269 1.125 10.2692 1.125H3.98081C3.92306 1.125 3.87019 1.14906 3.82219 1.19719C3.77406 1.24519 3.75 1.29806 3.75 1.35581V9.89419C3.75 9.95194 3.77406 10.0048 3.82219 10.0528C3.87019 10.1009 3.92306 10.125 3.98081 10.125ZM1.35581 13.875C0.976937 13.875 0.65625 13.7438 0.39375 13.4813C0.13125 13.2188 0 12.8981 0 12.5192V2.85581H1.125V12.5192C1.125 12.5769 1.14906 12.6298 1.19719 12.6778C1.24519 12.7259 1.29806 12.75 1.35581 12.75H8.76919V13.875H1.35581Z",
    fill: "#A1A1AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.44eb5e0552509e334b01628718ed1f25.svg";
export { ForwardRef as ReactComponent };